module.exports = __webpack_public_path__ + "img/2_cnc_1.d59a1960.jpg";